import {
  SHOW_PAGE_FAIL,
  SHOW_PAGE_REQUEST,
  SHOW_PAGE_SUCCESS,
} from "../../ActionType/BranchType/PageType";

export const showPageReducer = (
  state = { loading: true, pages: [], error: "" },
  action
) => {
  switch (action.type) {
    case SHOW_PAGE_REQUEST:
      return {
        loading: true,
        pages: action.payload,
      };
    case SHOW_PAGE_SUCCESS:
      return {
        loading: false,
        pages: action.payload,
        error: "",
      };
    case SHOW_PAGE_FAIL:
      return {
        loading: false,
        pages: action.payload,
        error: "",
      };
    default:
      return state;
  }
};
